import _ from 'lodash';
/** import third-party libraries in the section above, Sort Lines Ascending */

import { ROLE_INTENTS, ALL_INTENTS } from 'common/constants/role-intents';
/** import multi application imports in the section above, Sort Lines Ascending */

import store from 'core/store';
/** import single application imports in the section above, Sort Lines Ascending */

const ROOT_ORG = '53271100d26f9a2f917ed289';
export const ADDICTIVE_ORG = '53271100d26f9a2f917ed290';
export const SELF_SERVE_ROOT_ORG = '57c5f37c3fa5a4b6820a48c3';
const SPAIN_ROOT_ORG = '53271100d26f9a2f917ed289';
const ELTIEMPO_ORG = '5fd7da80f30daf4460d6ef35';

const INTERNAL_ORG_IDS = [
    ROOT_ORG,
    ADDICTIVE_ORG,
    SELF_SERVE_ROOT_ORG,
    SPAIN_ROOT_ORG,
    ELTIEMPO_ORG,
];

const PATTISON_OUTDOOR_SELF_SERVE_ORG = '684052fbd26e86b1078e0909';

const PELMOREX_MARKETING_ORG = '652da54981552e41ca230cdc';

export const ORG_ID_LENGTH = 24; // 24 characters long

export const INTERNAL_ORG_IDS_FOR_IMPERSONATION = [...INTERNAL_ORG_IDS, PELMOREX_MARKETING_ORG];

export const TOP_ORG_IDS_FOR_REPORTING = INTERNAL_ORG_IDS_FOR_IMPERSONATION.filter(
    orgId => orgId !== SELF_SERVE_ROOT_ORG
);

// @object profileState
// @string || @string[] intents
export function userCan(profileState, intents) {
    const finalRole = _.get(profileState, 'globalRole');

    let finalIntents = typeof intents === 'string' ? [intents] : intents;

    return _.every(finalIntents, intent => {
        // Check if the incoming intent exists
        if (ALL_INTENTS[intent] === undefined) {
            throw new Error(`Invalid intent: ${intent}`);
        }

        return !!_.get(ROLE_INTENTS, `${finalRole}.${intent}`);
    });
}

// The big difference here is that it confirms that the underlying user
// has permission to do the action. For impersonated sessions, this means
// the original user. For regular user sessions, it means the regular user.
//
// @object profileState
// @string || @string[] intents
export function userTrulyCan(profileState, intents) {
    const finalRole = _.get(profileState, 'authToken.v3_impersonator.role');

    let finalIntents = typeof intents === 'string' ? [intents] : intents;

    return _.every(finalIntents, intent => {
        // Check if the incoming intent exists
        if (ALL_INTENTS[intent] === undefined) {
            throw new Error(`Invalid intent: ${intent}`);
        }
        return !!_.get(ROLE_INTENTS, `${finalRole}.${intent}`);
    });
}

export function isInternalUser() {
    const orgId = _.get(store.getState(), 'profile.organizationId');

    // Internal users are part of Root, Addictive Mobility org, Spain root, or elTiempo
    return _.includes(INTERNAL_ORG_IDS, orgId);
}

export function isAddictiveMobilityUser() {
    const orgId = _.get(store.getState(), 'profile.organizationId');
    return orgId === ADDICTIVE_ORG;
}

export function isRootUser() {
    const orgId = _.get(store.getState(), 'profile.organizationId');
    return orgId === ROOT_ORG;
}

/**
 * Checks if the current user belongs to the Pattison Outdoor (Self serve) organization.
 *
 * @returns {boolean} True if the user is part of the Pattison Outdoor Self serve) organization, false otherwise.
 */
export function isPatisonOutdoorSelfServeUser() {
    const orgId = _.get(store.getState(), 'profile.organizationId');
    return orgId === PATTISON_OUTDOOR_SELF_SERVE_ORG;
}
/**
 * Checks if the user is part of the Root or Spain root organization,
 * either directly or through impersonation.
 * This should be uses carefully: ideally, when impersonating, the impersonator should have exactly the same
 * permissions as the impersonated user.
 *
 * @returns {boolean} True if the user is part of the Root or Spain root organization, false otherwise.
 */
export function isRootOrImpersonatedByRoot() {
    const impersonatorOrUserOrganizationID = _.get(
        store.getState(),
        'profile.authToken.v3_impersonator.organization'
    );

    return [ROOT_ORG, SPAIN_ROOT_ORG].includes(impersonatorOrUserOrganizationID);
}
